import React, { useEffect, useState } from "react";
import { ClipboardCheck } from "lucide-react";
import { api } from "../lib/api";
import { MairieDocs } from "./demarches/DemarchesActions";

const STEP_FIELDS = { dp_mairie: ["mairie", "dp", "tacite"], consuel: ["consuel"], raccordement: ["raccordement", "pdl", "prm"], tva: ["tva"] };
const PV_STEPS = ["consuel", "raccordement", "tva"];
const ST = { done: ["Terminé", "bg-emerald-50 text-emerald-800 border-emerald-200"], in_progress: ["En cours", "bg-sky-50 text-sky-800 border-sky-200"],
  blocked: ["Bloqué", "bg-red-50 text-red-800 border-red-200"], pending: ["À faire", "bg-slate-50 text-slate-600 border-slate-200"] };
const fmt = (f, v) => (f.type === "date" && v ? new Date(`${String(v).slice(0, 10)}T12:00:00`).toLocaleDateString("fr-FR") : v);

export default function DemarchesSyntheseCard({ dossier }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    Promise.all([api.get("/configuration/tab-schema/demarches"), api.get(`/dossiers/${dossier.id}/tab-data/demarches`)])
      .then(([s, t]) => setD({ schema: s.data, data: t.data })).catch(() => setD(null));
  }, [dossier.id, dossier.updated_at]);
  if (!d) return null;
  const isPv = (dossier.extraction?.produit || "").toUpperCase() === "PV";
  const steps = (d.schema.workflow || []).filter((st) => isPv || !PV_STEPS.includes(st.id));
  const vals = d.data.values || {};
  const wf = d.data.workflow_statuses || {};
  const fieldsOf = (st) => d.schema.fields.filter((f) => !f.hidden && (!f.produits?.length || f.produits.includes(isPv ? "PV" : "")) && (STEP_FIELDS[st.id] || [st.id]).some((k) => f.id.includes(k)));
  const open = () => window.dispatchEvent(new CustomEvent("norea:open-tab", { detail: "demarches" }));
  return (
    <section className="card-flat p-5" data-testid="demarches-synthese-card">
      <div className="flex items-center justify-between mb-3"><h3 className="font-heading text-base font-medium inline-flex items-center gap-2"><ClipboardCheck className="w-4 h-4 text-norea-primary" />Synthèse des démarches</h3>
        <button onClick={open} className="text-[11px] text-norea-textMuted hover:underline" data-testid="demarches-synthese-open">Ouvrir l'onglet Démarches</button></div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
        {steps.map((st) => {
          const [lab, cls] = ST[wf[st.id]] || ST.pending;
          return (
            <div role="button" tabIndex={0} key={st.id} onClick={open} className="cursor-pointer text-left rounded-lg border border-norea-border p-3 hover:bg-norea-surfaceHover transition-colors" data-testid={`demarche-${st.id}`}>
              <div className="flex items-center justify-between gap-2 mb-1.5"><b className="text-sm">{st.label}</b><span className={`text-[11px] px-1.5 py-0.5 rounded border ${cls}`} data-testid={`demarche-status-${st.id}`}>{lab}</span></div>
              {fieldsOf(st).map((f) => (
                <div key={f.id} className="flex justify-between gap-2 text-[11px]"><span className="text-norea-textMuted truncate">{f.label}</span><span className={vals[f.id] ? "font-medium" : "italic text-norea-textDisabled"}>{fmt(f, vals[f.id]) || "—"}</span></div>
              ))}
              {st.id === "dp_mairie" && <div className="mt-2"><MairieDocs dossierId={dossier.id} refresh={dossier.updated_at} /></div>}
            </div>
          );
        })}
      </div>
    </section>
  );
}
